


































































































































import Vue from "vue";
import SelectBox from "@/components/util/SelectBox.vue";
import { sendMemberRegister, getMembers, deleteMember, updateCorporationManagementRole, updateJoinProject } from "@/api/CorporateMember";
import { getUserProfile } from "../../api/UserProfile";
import { getProjects } from "@/api/Corporation";
import { Project } from '@/api/dto/Corporation';
import { Role, MemberResponse, AllProjectCheck } from "@/api/dto/CorporateMember";
import axios from "axios";
import { ErrorResponse } from "@/api/dto/Error";

interface Data {
  project: false,
  project2: false,
  inputRole: string,
  inputMailAddress: string,
  selectRoles: Role[],
  submitModal: boolean,
  setKeyword: string,
  members: DispMember[],
  projects: Project[],
  checkProjects: Project[],
  updateCheckProjects: Project[],
  overIconModal: boolean,
  deleteMemberConfirmModal: boolean,
  updateMemberModal: boolean,
  openMember: DispMember,
  isApiProcessing: boolean,
}

interface DispMember {
  member: MemberResponse,
  active: boolean
}
export default Vue.extend({
  name: 'Member',
  components: {
    SelectBox,
  },
  data(): Data {
    return {
      project: false,
      project2: false,
      inputRole: "1",
      inputMailAddress: "",
      selectRoles: [
              { value: "1", text: "一般権限" },
              { value: "2", text: "管理者権限" },
             ],
      submitModal: false,
      setKeyword: '',
      members: [] as DispMember[],
      projects: [],
      checkProjects: [],
      updateCheckProjects: [],
      overIconModal: false,
      deleteMemberConfirmModal: false,
      updateMemberModal: false,
      openMember: {} as DispMember,
      isApiProcessing: false,
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      // 表示用情報取得
      const members = await getMembers();
      const projects = await getProjects();
      const dispMembers = [] as DispMember[];
      members.forEach((member) => {
        dispMembers.push({member: member, active: false})
      })

      next(vm => {
        (vm.$data as Data).members = dispMembers;
        (vm.$data as Data).projects = projects;
      });
    } catch (e) {
      // APIエラー
      next({ name: "Top" });
    }
  },
  computed: {
    filteredMember(): DispMember[] {
      if(this.setKeyword) { 
        return this.members.filter(value =>  value.member.nickname?.includes(this.setKeyword) 
          || value.member.mailAddress?.includes(this.setKeyword)
          || value.member.role?.includes(this.setKeyword));
      } else {
        return this.members;
      }
    },
    getDispUpdateMember(): AllProjectCheck[] {
      return this.members.find(v => v.member.id == this.openMember.member.id)!!.member.projectList.allProjectCheckList
    },
  },
  methods: {
    checkProjectListSize(member: DispMember): boolean {
      if (member.member.projectList.checkedProjectList.length > 10) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * プロジェクトアイコンモーダルを開く
     */
    openOverIconModal(member: DispMember) {
      this.overIconModal = true;
      this.openMember = member;
    },
    /**
     * メンバー削除モーダルを開く
     */
    openDeleteMemberModal(member: DispMember) {
      this.openMember = member;
      this.deleteMemberConfirmModal = true;
    },
    /**
     * メンバー更新（プロジェクト編集）モーダルを開く
     */
    openUpdateMemberModal(member: DispMember) {
      this.openMember = member;
      this.updateMemberModal = true;
    },
    popupOpen(member: DispMember) {
      const beforeActive = member.active;
      this.members.map ( v => v.active = false);
      if (beforeActive) {
        member.active = false;
      } else {
        member.active = true;
      }
    },
    /**
     * メンバーの新規追加
     */
    async submit() {
      const userProf = await getUserProfile();
      try {
        await sendMemberRegister({
          mailAddress: this.inputMailAddress,
          role: this.inputRole,
          corporateId: userProf.corporationsData.corporateId,
          projectList: this.checkProjects,
        });
      } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var resError = error.response.data as ErrorResponse;
            if (resError.message != null) {
              this.$emit('errorToast', resError.message);
            }
        } else {
          this.$emit('errorToast', 'メールの送信に失敗しました');
        }
        this.submitModal = false;
        return;
      }
      this.submitModal = false;
      this.$emit('toast', 'メールを送信しました');
    },
    /**
     * 管理者権限の更新
     */
    async updateCorporationManagementRole(member: DispMember, isManagement: boolean) {
      try {
        this.isApiProcessing = true;
        const members = await updateCorporationManagementRole({
          isManagement: isManagement,
          userId: member.member.id,
        })
        // 再描画用のデータ取得
        const dispMembers = [] as DispMember[];
        members.forEach((member) => {
          dispMembers.push({member: member, active: false})
        })
        this.members = dispMembers;

        if (this.$store.state.user.nickname == member.member.nickname) {
          this.$emit('toast', '自身の管理者権限を更新したため、ログアウトしました。再ログインしてください。');
          this.$store.dispatch("logout");
          this.$router.push({ name: "CorporateLogin" }, () => {});
        } else {
          this.$emit('toast', '管理者権限を更新しました');
        }

      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          this.$emit('errorToast', resError.message);
        }
      } finally {
        this.isApiProcessing = false;
      }
    },
    /**
     * 参加プロジェクト編集
     */
    async updateJoinProject() {
      const checkProjects = this.getDispUpdateMember;
      try {
        const members = await updateJoinProject(this.openMember.member.id, { checkProjects: checkProjects});
        // 再描画用のデータ取得
        const dispMembers = [] as DispMember[];
        members.forEach((member) => {
          dispMembers.push({member: member, active: false})
        })
        this.members = dispMembers;
      } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var resError = error.response.data as ErrorResponse;
            if (resError.message != null) {
              this.$emit('errorToast', resError.message);
            }
        } else {
          this.$emit('errorToast', '参加プロジェクトの編集に失敗しました');
        }
        this.updateMemberModal = false;
        return;
      }
      
      this.updateMemberModal = false;
      this.$emit('toast', '参加プロジェクトを編集しました');
    },
    /**
     * メンバー削除
     */
    async deleteMember() {
      try {
        this.isApiProcessing = true;
        await deleteMember(this.openMember.member.id)
        // 再描画用のデータ取得
        const members  = await getMembers();
        const dispMembers = [] as DispMember[];
        members.forEach((member) => {
          dispMembers.push({member: member, active: false})
        })
        this.members = dispMembers;
        this.$emit('toast', 'メンバーを削除しました');
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          this.$emit('errorToast', resError.message);
        }
      } finally {
        this.deleteMemberConfirmModal = false;
        this.isApiProcessing = false;
      }
    }
  }
})
